'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _userUtil = require('../../../user/userUtil');

var _ElectronLink = require('../../../components/electron/ElectronLink');

var _ElectronLink2 = _interopRequireDefault(_ElectronLink);

require('./ReferUtil.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReferUtil = function ReferUtil(_ref) {
    var navigateToRefer = _ref.navigateToRefer,
        currentUser = _ref.currentUser;

    if ((0, _userUtil.isGuest)(currentUser) || (0, _userUtil.isSubscribed)(currentUser)) return null;

    return _react2.default.createElement(
        _ElectronLink2.default,
        { to: '/account/refer', className: 'PillButton ReferUtil' },
        'Refer a friend, get more space'
    );
};

ReferUtil.propTypes = {
    currentUser: _propTypes2.default.object,
    navigateToRefer: _propTypes2.default.func
};

exports.default = ReferUtil;


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/header/utils/ReferUtil.js
// module id = 2165
// module chunks = 0